import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var InstanceChecker = /*#__PURE__*/function () {
  function InstanceChecker() {
    _classCallCheck(this, InstanceChecker);
  }
  _createClass(InstanceChecker, null, [{
    key: "isMssqlParameter",
    value: function isMssqlParameter(obj) {
      return this.check(obj, "MssqlParameter");
    }
  }, {
    key: "isEntityMetadata",
    value: function isEntityMetadata(obj) {
      return this.check(obj, "EntityMetadata");
    }
  }, {
    key: "isColumnMetadata",
    value: function isColumnMetadata(obj) {
      return this.check(obj, "ColumnMetadata");
    }
  }, {
    key: "isQueryBuilder",
    value: function isQueryBuilder(obj) {
      return this.check(obj, "QueryBuilder") || this.check(obj, "SelectQueryBuilder") || this.check(obj, "InsertQueryBuilder") || this.check(obj, "DeleteQueryBuilder") || this.check(obj, "UpdateQueryBuilder") || this.check(obj, "SoftDeleteQueryBuilder") || this.check(obj, "RelationQueryBuilder");
    }
  }, {
    key: "isSelectQueryBuilder",
    value: function isSelectQueryBuilder(obj) {
      return this.check(obj, "SelectQueryBuilder");
    }
  }, {
    key: "isInsertQueryBuilder",
    value: function isInsertQueryBuilder(obj) {
      return this.check(obj, "InsertQueryBuilder");
    }
  }, {
    key: "isDeleteQueryBuilder",
    value: function isDeleteQueryBuilder(obj) {
      return this.check(obj, "DeleteQueryBuilder");
    }
  }, {
    key: "isUpdateQueryBuilder",
    value: function isUpdateQueryBuilder(obj) {
      return this.check(obj, "UpdateQueryBuilder");
    }
  }, {
    key: "isSoftDeleteQueryBuilder",
    value: function isSoftDeleteQueryBuilder(obj) {
      return this.check(obj, "SoftDeleteQueryBuilder");
    }
  }, {
    key: "isRelationQueryBuilder",
    value: function isRelationQueryBuilder(obj) {
      return this.check(obj, "RelationQueryBuilder");
    }
  }, {
    key: "isBrackets",
    value: function isBrackets(obj) {
      return this.check(obj, "Brackets") || this.check(obj, "NotBrackets");
    }
  }, {
    key: "isNotBrackets",
    value: function isNotBrackets(obj) {
      return this.check(obj, "NotBrackets");
    }
  }, {
    key: "isSubject",
    value: function isSubject(obj) {
      return this.check(obj, "Subject");
    }
  }, {
    key: "isRdbmsSchemaBuilder",
    value: function isRdbmsSchemaBuilder(obj) {
      return this.check(obj, "RdbmsSchemaBuilder");
    }
  }, {
    key: "isMongoEntityManager",
    value: function isMongoEntityManager(obj) {
      return this.check(obj, "MongoEntityManager");
    }
  }, {
    key: "isSqljsEntityManager",
    value: function isSqljsEntityManager(obj) {
      return this.check(obj, "SqljsEntityManager");
    }
  }, {
    key: "isEntitySchema",
    value: function isEntitySchema(obj) {
      return this.check(obj, "EntitySchema");
    }
  }, {
    key: "isBaseEntityConstructor",
    value: function isBaseEntityConstructor(obj) {
      return typeof obj === "function" && typeof obj.hasId === "function" && typeof obj.save === "function" && typeof obj.useDataSource === "function";
    }
  }, {
    key: "isFindOperator",
    value: function isFindOperator(obj) {
      return this.check(obj, "FindOperator") || this.check(obj, "EqualOperator");
    }
  }, {
    key: "isEqualOperator",
    value: function isEqualOperator(obj) {
      return this.check(obj, "EqualOperator");
    }
  }, {
    key: "isQuery",
    value: function isQuery(obj) {
      return this.check(obj, "Query");
    }
  }, {
    key: "isTable",
    value: function isTable(obj) {
      return this.check(obj, "Table");
    }
  }, {
    key: "isTableCheck",
    value: function isTableCheck(obj) {
      return this.check(obj, "TableCheck");
    }
  }, {
    key: "isTableColumn",
    value: function isTableColumn(obj) {
      return this.check(obj, "TableColumn");
    }
  }, {
    key: "isTableExclusion",
    value: function isTableExclusion(obj) {
      return this.check(obj, "TableExclusion");
    }
  }, {
    key: "isTableForeignKey",
    value: function isTableForeignKey(obj) {
      return this.check(obj, "TableForeignKey");
    }
  }, {
    key: "isTableIndex",
    value: function isTableIndex(obj) {
      return this.check(obj, "TableIndex");
    }
  }, {
    key: "isTableUnique",
    value: function isTableUnique(obj) {
      return this.check(obj, "TableUnique");
    }
  }, {
    key: "isView",
    value: function isView(obj) {
      return this.check(obj, "View");
    }
  }, {
    key: "isDataSource",
    value: function isDataSource(obj) {
      return this.check(obj, "DataSource");
    }
  }, {
    key: "check",
    value: function check(obj, name) {
      return typeof obj === "object" && obj !== null && obj["@instanceof"] === Symbol.for(name);
    }
  }]);
  return InstanceChecker;
}();